import React from 'react';
import type { FC } from 'react';
import { useIntl } from 'react-intl-next';

import Heading from '@atlaskit/heading';
import { token } from '@atlaskit/tokens';
import { Box, Inline, Stack, Text, xcss } from '@atlaskit/primitives';
import { i18n } from '../automation-modal/AutomationModalHeader';
import PresenterModeIcon from '@atlaskit/icon/core/presenter-mode';

import { useAutomationMenu } from '../common/ConfluenceManualRulesContainer';

type AutomationModalHeaderProps = {
	contentTitle: string;
	title: string;
};

const iconStyle = xcss({
	marginRight: 'space.150',
	backgroundColor: 'color.background.accent.green.subtlest',
	borderRadius: 'border.radius',
});

const contextHintStyle = xcss({
	marginTop: 'space.150',
});

export const AutomationRovoButtonHeader: FC<AutomationModalHeaderProps> = ({
	contentTitle,
	title,
}) => {
	const { formatMessage } = useIntl();

	const { initialised, rules } = useAutomationMenu();

	const showHint = initialised && rules.length > 0;
	const contextHint = formatMessage(i18n.modalHeaderContextHint, {
		contentTitle,
		b: (chunks: React.ReactNode[]) => <Text weight="bold">{chunks}</Text>,
	});

	return (
		<Stack>
			<Inline alignBlock="center">
				<Box
					xcss={iconStyle}
					paddingInline="space.050"
					paddingBlock="space.025"
					testId="automation-header-icon"
				>
					<PresenterModeIcon label="" color={token('color.icon.accent.green')} />
				</Box>
				<Heading size="medium">{title}</Heading>
			</Inline>
			{showHint && (
				<Box xcss={contextHintStyle}>
					{contextHint}
					<div>{formatMessage(i18n.modalHeaderContextDescription)}</div>
				</Box>
			)}
		</Stack>
	);
};
